import { createTypes, async, asyncActionCreator } from 'redux-action-creator';
import { getWaivers, updateChangeEventId } from '../../../../service/waiverService';
import { ThunkAction } from '../../../types';
import { Waiver } from '../../../../types/waiver';

export const types = createTypes(
  [...async('FETCH_WAIVERS'), ...async('UPDATE_CHANGE_EVENT_ID')],
  'WAIVER',
);

export const fetchWaivers = asyncActionCreator(types.FETCH_WAIVERS, () =>
  getWaivers(),
);

interface WaiverChangeEventUpdate {
  waiver: Waiver;
  changeEventId: number;
};

export const updateWaiverChangeEventId: (params: WaiverChangeEventUpdate) => ThunkAction = asyncActionCreator(
  types.UPDATE_CHANGE_EVENT_ID,
  {
    action: ({ waiver, changeEventId }: WaiverChangeEventUpdate) =>
      updateChangeEventId(waiver, changeEventId),
  },
);
